import { z } from "zod";
import api from "./api";
import { BASE_URL } from "./auth";

const microsoftDocumentSchema = z.object({
  file: z.instanceof(File),
  description: z.string(),
  document_type: z.enum(["template", "library"]).optional().default("template"),
  name: z.string(),
  reset_text_boxes: z.boolean().optional().default(false),
});

type MicrosoftDocumentSchema = z.infer<typeof microsoftDocumentSchema>;

export async function createMicrosoftDocument(
  payload: MicrosoftDocumentSchema
) {
  const validateData = microsoftDocumentSchema.safeParse(payload);
  if (!validateData.success) {
    return validateData.error.format();
  }
  const formData = new FormData();
  formData.append("file", validateData.data.file);
  formData.append("description", validateData.data.description);
  formData.append("document_type", validateData.data.document_type);
  formData.append("name", validateData.data.name);
  formData.append(
    "reset_text_boxes",
    validateData.data.reset_text_boxes.toString()
  );
  const response = await api.post(`${BASE_URL}/documents/pptx`, formData, {
    timeout: 0,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}
